module.exports = __webpack_public_path__ + "assets/img/mecha-btn-8a0281c1.png";